import { gql } from "@apollo/client";

export const GET_DETALLE_PRECIO_MASIVO = gql`
query GetDetallePrecioMasivo($idPrecioMasivo: Long!) {
  detallePrecioMasivo (idPrecioMasivo: $idPrecioMasivo) {
    success,
    error,
    valorEsperado {
      idEvaluacion,
      delegacion,
      cod_Sap,
      cliente,
      paciente,
      precioDiario,
      precioAModificar,
      viable,
      precioSAP,
      tipoPrecio,
      vigencia,
      precioControl,
      periodo,
      gerenteO,
      gerenteG,
      existe
    }
  } 
}
`;